import { z } from "zod";

const UpdateLinkRateResponse = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.object({
        id: z.string().uuid(),
        room_type_id: z.string().uuid(),
        property_id: z.string().uuid(),
        // Nullable: property deactivation nulls this server-side (DeactivatePropertyChannexJob).
        channex_id: z.string().uuid().nullable(),
        name: z.string(),
        description: z.nullable(z.string()),
        max_night: z.coerce.number().min(0),
        min_night: z.coerce.number().min(1),
        guest_include: z.coerce.number().min(1),
        guest_max: z.coerce.number().min(1),
        extra_adult: z.coerce.number(),
        extra_child: z.coerce.number(),
        extra_adult_rate: z.string().regex(/^\d+(\.\d{2})?$/, "Invalid currency format"),
        extra_child_rate: z.string().regex(/^\d+(\.\d{2})?$/, "Invalid currency format"),
        rate: z.string().regex(/^\d+(\.\d{2})?$/, "Invalid currency format"),
        min_rate: z.string().regex(/^\d+(\.\d{2})?$/, "Invalid currency format"),
        start_date: z.nullable(z.string().datetime()),
        end_date: z.nullable(z.string().datetime()),
        parent_id: z.string().uuid(),
        specific_rule: z.enum(["increase", "decrease"]),
        specific_amount: z.string().regex(/^\d+(\.\d{2})?$/, "Invalid currency format"),
        specific_percent: z.number(),
        specific_amount_type: z.enum(["amount", "percent"]),
        created_at: z.string().datetime(),
        updated_at: z.string().datetime(),
        inherit_restriction: z.number().int().min(0).max(1),
    }),
});

export { UpdateLinkRateResponse };
export type UpdateLinkRateResponseType = z.infer<typeof UpdateLinkRateResponse>;
